module.exports = __webpack_public_path__ + "static/media/Agi01.3c4950aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Agi01.jpg
// module id = 344
// module chunks = 0